/**
 * TOC Collapse Functionality
 * Collapses #ez-toc-container to 310px with a fade overlay and toggle button
 */
(function () {
	'use strict';

	const MAX_HEIGHT = 238;

	document.addEventListener('DOMContentLoaded', function () {
		initTocCollapse();
	});

	function initTocCollapse() {
		const container = document.getElementById('ez-toc-container');
		if (!container) return;

		// Measure the natural height before collapsing
		const naturalHeight = container.scrollHeight;
		if (naturalHeight <= MAX_HEIGHT) return;

		// Apply collapsed state
		container.classList.add('ez-toc-collapsed');
		container.style.maxHeight = MAX_HEIGHT + 'px';

		// Create button wrapper
		const btnWrapper = document.createElement('div');
		btnWrapper.className = 'ez-toc-collapse-btn-wrapper';

		const btn = document.createElement('button');
		btn.className = 'ez-toc-collapse-btn';
		btn.setAttribute('aria-expanded', 'false');
		btn.innerHTML =
			getLabel('showMore') + ' <i data-icon="uiAngleBottom" data-icon-size="24px">';

		btnWrapper.appendChild(btn);
		container.insertAdjacentElement('afterend', btnWrapper);

		btn.addEventListener('click', function () {
			const isCollapsed = container.classList.contains('ez-toc-collapsed');

			if (isCollapsed) {
				container.classList.remove('ez-toc-collapsed');
				container.style.maxHeight = container.scrollHeight + 'px';
				btn.setAttribute('aria-expanded', 'true');
				btn.innerHTML =
					getLabel('showLess') + ' <i data-icon="uiAngleTop" data-icon-size="24px">';

				// After transition, remove max-height to allow natural flow
				container.addEventListener(
					'transitionend',
					function onEnd() {
						container.removeEventListener('transitionend', onEnd);
						container.style.maxHeight = 'none';
					},
					{ once: true }
				);
			} else {
				// Set current height explicitly so transition works
				container.style.maxHeight = container.scrollHeight + 'px';

				// Force reflow
				container.offsetHeight; // eslint-disable-line no-unused-expressions

				container.classList.add('ez-toc-collapsed');
				container.style.maxHeight = MAX_HEIGHT + 'px';
				btn.setAttribute('aria-expanded', 'false');
				btn.innerHTML =
					getLabel('showMore') + ' <i data-icon="uiAngleBottom" data-icon-size="24px">';
			}
		});
	}

	function getLabel(key) {
		const config = window.tocCollapseConfig || {};
		const defaults = {
			showMore: 'Show more',
			showLess: 'Show less',
		};
		return config[key] || defaults[key];
	}
})();
